var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"transform top-0 left-0 w-64 bg-white fixed h-full overflow-auto ease-in-out transition-all duration-300 z-30",class:_vm.isOpen ? 'translate-x-0' : '-translate-x-full'},[_c('h1',[_vm._v("teste")])])}
var staticRenderFns = []

export { render, staticRenderFns }